module.exports = __webpack_public_path__ + "img/sec3_5.6ac0381a.png";